import {makeAutoObservable} from "mobx";


class PaymentStore {
    paymentMethod = null
    plan_id = null
    isPaymentSelected = false
    isPaymentProcessed = false
    paymentStatus = false
    paymentPush = false
    email = undefined
    isValidEmail = false
    tx_id = false
    isPaymentUrlOpened = false
    paymentUrl = null
    paymentTimer = 10
    isStatusWindowOpened = null
    cryptoCurrency = null



    constructor() {
        makeAutoObservable(this)
    }

    setCryptoCurrency(currency) {
        this.cryptoCurrency = currency
    }

    setIsStatusWindowOpened(state) {
        this.isStatusWindowOpened = state
    }
    setPaymentMethod(paymentMethod) {
        this.paymentMethod = paymentMethod;
        this.isPaymentSelected = true;
    }

    setPaymentStatus(state){
        this.paymentStatus = state
    }

    setPaymentProcessed(state) {
        this.isPaymentProcessed = state
    }

    setIsPaymentSelected(isPaymentSelected) {
        this.isPaymentSelected = isPaymentSelected;
    }

    clearPaymentMethod() {
        this.paymentMethod = null
    }
    setPlanId(plan_id) {
        this.plan_id = plan_id;
    }

    setPaymentPush(state) {
        this.paymentPush = state;
    }

    setEmail(email) {
        this.email = email;
    }

    setIsValidEmail(state) {
        this.isValidEmail = state
    }

    setPaymentUrl(url) {
        this.paymentUrl = url;
    }

    setTxId(txId) {
        this.tx_id = txId;
    }

    setIsPaymentUrlOpened (state) {
        this.isPaymentUrlOpened = state
    }

    setPaymentTimer(time) {
        this.paymentTimer = time;
    }

    resetTimer() {
        this.paymentTimer = 10
    }

    resetPayment() {
        this.paymentMethod = null
        this.isPaymentSelected = false
        this.isPaymentProcessed = false
        this.paymentStatus = false
        this.tx_id = false
        this.isPaymentUrlOpened = false
        this.paymentUrl = null
        this.paymentTimer = 10
        this.isStatusWindowOpened = false

    }

}

export default new PaymentStore();